// extracted by mini-css-extract-plugin
export default {"scrollableUserList":"UsersList-module__scrollableUserList__Y5EJLFh"};